/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Cmp_4_PInputs */

const en_cp_cmp_4_p = /** @type {(inputs: Cp_Cmp_4_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1000 Startup Digital · Indigo · campus incubators`)
};

const id_cp_cmp_4_p = /** @type {(inputs: Cp_Cmp_4_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1000 Startup Digital · Indigo · inkubator kampus`)
};

/**
* | output |
* | --- |
* | "1000 Startup Digital · Indigo · campus incubators" |
*
* @param {Cp_Cmp_4_PInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_cmp_4_p = /** @type {((inputs?: Cp_Cmp_4_PInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Cmp_4_PInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_cmp_4_p(inputs)
	return en_cp_cmp_4_p(inputs)
});